/* NUOMA 3.0.6 · Prévu pour les médias 3D natifs Shopify, aucun abonnement externe requis. */
(() => {
  'use strict';
  const dialogs = () => document.querySelectorAll('[data-nuoma-ar-dialog]');
  const xrInitialized = new WeakSet();

  function initializeXR(dialog) {
    if (!dialog || xrInitialized.has(dialog)) return;
    const modelData = dialog.querySelector('[data-nuoma-ar-models]');
    if (!modelData) return;
    xrInitialized.add(dialog);
    let models = [];
    try { models = JSON.parse(modelData.textContent || '[]'); } catch (_) { return; }
    if (!models.length || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    try {
      window.Shopify.loadFeatures([
        { name: 'model-viewer-ui', version: '1.0', onLoad: () => {} },
        { name: 'shopify-xr', version: '1.0', onLoad: (errors) => {
          if (errors) return;
          const register = () => {
            if (!window.ShopifyXR) return;
            try { window.ShopifyXR.addModels(models); } catch (_) { /* Le mode 3D reste utilisable. */ }
          };
          if (window.ShopifyXR) register();
          else document.addEventListener('shopify_xr_initialized', register, { once: true });
        } }
      ]);
    } catch (_) { /* AR facultative ; la visualisation reste affichée. */ }
  }

  function openDialog(button) {
    const id = button.getAttribute('data-nuoma-ar-open');
    const dialog = id ? document.getElementById(id) : null;
    if (!dialog) return;
    dialog._nuomaTrigger = button;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    initializeXR(dialog);
    const closeButton = dialog.querySelector('.nuoma-ar-dialog__close');
    if (closeButton) closeButton.focus();
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    const trigger = dialog._nuomaTrigger;
    if (trigger && trigger.isConnected) trigger.focus();
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-nuoma-ar-open]');
    if (opener) { event.preventDefault(); openDialog(opener); return; }

    const closer = event.target.closest('[data-nuoma-ar-close]');
    if (closer) { event.preventDefault(); closeDialog(closer.closest('[data-nuoma-ar-dialog]')); return; }

    const xrButton = event.target.closest('[data-nuoma-ar-xr]');
    if (xrButton) {
      event.preventDefault();
      const feedback = xrButton.closest('[data-nuoma-ar-dialog]')?.querySelector('[data-nuoma-ar-feedback]');
      if (window.ShopifyXR && typeof window.ShopifyXR.launchXR === 'function') {
        try {
          window.ShopifyXR.launchXR({
            model3dId: Number(xrButton.dataset.modelId),
            title: xrButton.dataset.modelTitle || document.title
          });
          if (feedback) feedback.textContent = '';
          return;
        } catch (_) { /* Navigateur ou appareil incompatible. */ }
      }
      const viewer = xrButton.closest('[data-nuoma-ar-dialog]')?.querySelector('model-viewer');
      if (viewer && typeof viewer.activateAR === 'function') {
        try { viewer.activateAR(); if (feedback) feedback.textContent = ''; return; } catch (_) { /* Mode indisponible. */ }
      }
      if (feedback) feedback.textContent = 'Pour utiliser la caméra, ouvrez cette page dans Safari (iPhone) ou Chrome (Android) sur un appareil compatible.';
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target;
    if (dialog.matches && dialog.matches('[data-nuoma-ar-dialog]')) closeDialog(dialog);
  });

  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (dialog.matches && dialog.matches('[data-nuoma-ar-dialog]')) {
      const trigger = dialog._nuomaTrigger;
      if (trigger && trigger.isConnected) trigger.focus();
    }
  }, true);

  // Shopify peut recharger uniquement la section pendant la personnalisation.
  document.addEventListener('shopify:section:load', () => {
    dialogs().forEach((dialog) => { if (dialog.open) initializeXR(dialog); });
  });
})();
